/**
 * System Settings types.
 *
 * @class SystemSettingsTypes
 * @name types
 * @memberof Mojito.Core.Services.SystemSettings
 */
export default class SystemSettingsTypes {}

/**
 * Available application modes.
 *
 * @typedef APPLICATION_MODE
 * @property {string} MOBILE - Mobile application mode.
 * @property {string} DESKTOP - Desktop application mode.
 * @memberof Mojito.Core.Services.SystemSettings.types
 */
SystemSettingsTypes.APPLICATION_MODE = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop',
};

/**
 * Enum for the communication channels from which a Mojito API request can originate.
 * For instance, a request might come from either a mobile or desktop device.
 *
 * @readonly
 * @enum {string}
 * @memberof Mojito.Core.Services.SystemSettings.types
 */
SystemSettingsTypes.CHANNEL = {
    /** Mobile channel. Application is operating in mobile mode. */
    MOBILE: 'MOBILE',
    /** Desktop channel.  Application is operating in desktop mode. */
    DESKTOP: 'DESKTOP',
    /** Native channel.  Application is operating in native mode. */
    NATIVE: 'NATIVE',
    /** Retail channel. Application is operating as retail terminal. */
    RETAIL: 'RETAIL',
};

/**
 * Supported application modes.
 *
 * @typedef APPLICATION_MODES_SUPPORTED
 * @memberof Mojito.Core.Services.SystemSettings.types
 */
SystemSettingsTypes.APPLICATION_MODES_SUPPORTED = Object.values(
    SystemSettingsTypes.APPLICATION_MODE
);

/**
 * Default home page view for avantgarde Feed/Pro switcher.
 *
 * @typedef HOME_DEFAULT_VIEW
 * @memberof Mojito.Core.Services.SystemSettings.types
 */
SystemSettingsTypes.HOME_DEFAULT_VIEW = {
    FEED: 'feed',
    PRO: 'pro',
};

/**
 * User-selected color theme.
 *
 * @typedef COLOR_THEME
 * @memberof Mojito.Core.Services.SystemSettings.types
 */
SystemSettingsTypes.COLOR_THEME = {
    LIGHT: 'light',
    DARK: 'dark',
};

SystemSettingsTypes.HOME_DEFAULT_VIEWS_SUPPORTED = Object.values(
    SystemSettingsTypes.HOME_DEFAULT_VIEW
);

SystemSettingsTypes.COLOR_THEMES_SUPPORTED = Object.values(SystemSettingsTypes.COLOR_THEME);
